<template>
    <div>
        <v-card light :loading="loading">
            <section class="pa-5 mr-sm-4 ml-sm-7 pt-15">
                <v-row align="center">
                    <v-col class="blue-grey rounded" cols="12" sm="4">
                        <span class="subtitle-2 white--text">Unidad Administrativa</span>
                    </v-col>
                    <v-col cols="12" sm="8">
                        <v-autocomplete v-model="selectedDependencia" :items="dependencias" dense :filter="filter"
                            hide-details="auto" return-object item-text="nombre"
                            :loading="loadingDependencias"></v-autocomplete>
                    </v-col>
                </v-row>
                <v-row align="center">
                    <v-col class="blue-grey rounded" cols="12" sm="4">
                        <span class="subtitle-2 white--text">Serie</span>
                    </v-col>
                    <v-col cols="12" sm="8">
                        <v-autocomplete v-model="selectedSerie" :items="series" dense hide-details="auto"
                            :loading="loadingSeries" :filter="filter" return-object item-text="nombre"></v-autocomplete>
                    </v-col>
                </v-row>
                <v-row align="center">
                    <v-col class="blue-grey rounded" cols="12" sm="4">
                        <span class="subtitle-2 white--text">Subserie</span>
                    </v-col>
                    <v-col cols="12" sm="8">
                        <v-autocomplete v-model="selectedSubSerie" :items="subseries" dense hide-details="auto"
                            :loading="loadingSubSeries" :filter="filter" return-object
                            item-text="nombre"></v-autocomplete>
                    </v-col>
                </v-row>
            </section>
            <section class="pa-5 mx-sm-4 ">
                <v-divider class="mb-5"></v-divider>
                <!--TODO-Revisar este componente-->
                    <!-- <documentoTransferencia v-if="verFormulario" :mostrar="verFormulario" :relacionado="false"
                        :ultimaEntidad="ultimaEntidad" @cancelar="verFormulario = false" @oficioGuardado="
                            verFormulario = false;
                            getExpedientesVencidos();
                    " /> -->
                  <!-- <v-btn dark color="blue-grey" @click="verFormulario = true">
                        <v-icon dense>
                            mdi-file
                        </v-icon>
                    </v-btn> -->
                <v-row no-gutters justify=end class="mb-5">
                    <v-col cols="12" sm="4" class="d-flex align-center">
                        
                        <v-text-field v-model="search" label="Buscar" dense outlined hide-details class="mr-sm-2"
                            @keydown.enter="getExpedientesVencidos()"></v-text-field>
                        <v-btn dark color="blue-grey" @click="getExpedientesVencidos()">
                            <v-icon dense>
                                mdi-magnify
                            </v-icon>
                        </v-btn>
                    </v-col>
                </v-row>
                <v-data-table :headers="headers" :items="expedientes" :loading="loading" class="elevation-2"
                    hide-default-footer disable-sort no-data-text="No hay expedientes con el filtro selecccionado.">
                    <template v-slot:[`item.fechaCierre`]="{ item }">
                        <span>{{fecha(item.fechaCierre) }}</span>
                    </template>
                    <template v-slot:[`item.clave`]="{ item }">
                        <a @click.stop="verExpediente(item)">{{ item.clave }}</a>
                    </template>
                </v-data-table>
                <section class="d-flex flex-column">
                    <div class="my-4">
                        <v-pagination v-model="page" :length="tableLength" total-visible="10" color="blue-grey"></v-pagination>
                    </div>
                    <span class="grey--text text-center">Mostrando {{ (page != tableLength && page < tableLength) ? page
            * 10 : totalExpedientes }} de {{ totalExpedientes }} expedientes. </span>
                </section>
            </section>
        </v-card>
        <ver-expediente v-if="mostrar" :mostrar="mostrar" @cancelar="mostrar = false" :expediente="expediente"
            :ver="true" />
    </div>
</template>
<script>
import { getDependencias, getSeries, getSubSeries,rutaPrueba } from '../expedientes/expediente.service';
import { expedientesVencidos } from './archivo.service';
import VerExpediente from '../expedientes/agregarExpediente.vue';
import {DateTime} from 'luxon';
// import documentoTransferencia from "./documentoTransferencia"

export default {
    components: {
        VerExpediente,
        // documentoTransferencia
    },
    data: () => ({
        // verFormulario: false,
        mostrar: false,
        expediente: [],
        totalExpedientes: 0,
        search: '',
        page: 1,
        tableLength: 1,
        repoSeries: [],
        repoSubSeries: [],
        loading: false,
        loadingDependencias: false,
        loadingSeries: false,
        loadingSubSeries: false,
        dependencias: [],
        series: [],
        subseries: [],
        selectedDependencia: null,
        selectedSerie: null,
        selectedSubSerie: null,
        expedientes: [],
        headers: [
            { text: 'Clave', value: 'clave' },
            { text: 'Unidad Administrativa', value: 'unidadAdministrativa.nombre' },
            { text: 'Serie', value: 'serie.nombre' },
            { text: 'Subserie', value: 'subserie.nombre' },
            { text: 'Fecha de vencimiento', value: 'fechaCierre' },
            { text: 'Elaboró', value: 'elaboro.nombreCompleto' },
        ]
    }),
    watch: {
        selectedDependencia: function (dependencia) {
            this.loadingDependencias = true;
            this.series = this.getSeries(dependencia.subseries);
            this.selectedSerie = this.series[0] || null;
            if (this.haveElements())
                this.getExpedientesVencidos();
            this.loadingDependencias = false;
        },
        selectedSerie: async function () {
            this.loadingeries = true;
            this.subseries = this.getSubSeries();
            if (this.haveElements())
                this.getExpedientesVencidos();
            this.selectedSubSerie = this.subseries[0] || null;
            this.loadingSeries = false;
        },
        selectedSubSerie: function () {
            this.loadingSubSeries = true;
            if (this.haveElements())
                this.getExpedientesVencidos();
            this.loadingSubSeries = false;
        },
        $route: async function () {
            this.loading = true;
            try {
                if (!this.verifyQuery()) {
                    this.selectedDependencia = this.dependencias[0];
                    this.expedientes = [];
                    this.tableLength = 1;
                    this.page = 1;
                    const serverResponse = await expedientesVencidos(this.selectedDependencia._id, this.selectedSerie._id, this.selectedSubSerie._id, this.page, this.search);
                    if (!serverResponse.ok) throw new Error(serverResponse.mensaje);
                    this.expedientes = serverResponse.expedientes;
                    this.tableLength = serverResponse.totalPages;
                    this.totalExpedientes = serverResponse.total;
                    this.loading = false;
                    return;
                }
                this.page = parseInt(this.$route.query.page);
                this.search = this.$route.query.search;
                const serverResponse = await expedientesVencidos(this.selectedDependencia._id, this.selectedSerie._id, this.selectedSubSerie._id, this.page, this.search);
                if (!serverResponse.ok) throw new Error(serverResponse.mensaje);
                this.expedientes = serverResponse.expedientes;
                this.tableLength = serverResponse.totalPages;
                this.totalExpedientes = serverResponse.total;
                this.loading = false;
            } catch (error) {
                console.error(error);
                this.$notify({ group: 'gral_notif', type: "error", duration: 1500, speed: 500, text: error.message });
            }
            this.loading = false;
        },
        page: function () {
            this.$router.push({ path: 'archivo#vencidos', query: { ...this.$route.query, page: this.page } }).catch(() => { })
        },

    },
    async created() {
        try {
            this.loading = true;
            const serverResponse = await getDependencias();
            const serverResponseSeries = await getSeries();
            const serverResponseSubSeries = await getSubSeries();

            if (!serverResponse.ok) throw new Error(serverResponse.mensaje);
            if (!serverResponseSeries.ok) throw new Error(serverResponseSeries.mensaje);
            if (!serverResponseSubSeries.ok) throw new Error(serverResponseSubSeries.mensaje);

            this.repoSeries = serverResponseSeries.series;
            this.repoSubSeries = serverResponseSubSeries.subSeries;
            this.dependencias = serverResponse.dependencias.filter((dependencia) => dependencia.subseries);

            if (!this.verifyQuery()) this.selectedDependencia = this.dependencias[0];
            else {
                this.selectedDependencia = this.dependencias.find((dependencia) => dependencia._id == this.$route.query.dep);
                this.selectedSerie = this.repoSeries.find((serie) => serie._id == this.$route.query.ser);
                this.selectedSubSerie = this.repoSubSeries.find((subserie) => subserie._id == this.$route.query.sub);
                this.page = parseInt(this.$route.query.page);
                this.search = this.$route.query.search;
                if (!this.selectedDependencia || !this.selectedSerie || !this.selectedSubSerie) throw new Error('No se encontraron los datos de la consulta');
                const serverResponse = await expedientesVencidos(this.selectedDependencia._id, this.selectedSerie._id, this.selectedSubSerie._id, this.page, this.search || '');
                if (!serverResponse.ok) throw new Error(serverResponse.mensaje);
                this.expedientes = serverResponse.expedientes;
                this.tableLength = serverResponse.totalPages;
                this.totalExpedientes = serverResponse.total;
            }
        } catch (error) {
            console.error(error);
            this.$notify({ group: 'gral_notif', type: "error", duration: 1500, speed: 500, text: error.message });
        }
        this.loading = false;
    },
    methods: {
        filter(item, queryText, itemText) {
            const textOne = itemText.toLocaleLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, "");
            const textTwo = queryText.toLocaleLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, "");
            return textOne.indexOf(textTwo) > -1;
        },
        getSubSeries() {
            return this.repoSubSeries.filter((subserie) => this.selectedDependencia.subseries.includes(subserie._id) && this.selectedSerie._id == subserie.serie);
        },
        getSeries(subseries) {
            if (!subseries) return []
            const subseriesArray = this.repoSubSeries.filter((subserie) => this.selectedDependencia.subseries.includes(subserie._id));
            return subseriesArray.reduce((acc, subserie) => {
                const serie = this.repoSeries.find((serie) => serie._id == subserie.serie);
                if (!acc.includes(serie)) { acc.push(serie); }
                return acc;
            }, []);
        },
        getExpedientesVencidos() {
            this.$router.push({ path: 'archivo#vencidos', query: { page: '1', dep: this.selectedDependencia._id, ser: this.selectedSerie._id, sub: this.selectedSubSerie._id, search: this.search || '' } }).catch(() => { })
            this.page = 1;
        },
        verifyQuery() {
            const query = this.$route.query;
            if (query.page && query.dep && query.ser && query.sub) return true;
            return false;
        },
        verExpediente(expediente) {
            this.expediente = expediente;
            this.mostrar = true;
        },
        haveElements() {
            return this.selectedDependencia && this.selectedSerie && this.selectedSubSerie;
        },
        fecha(fecha){
            return DateTime.fromISO(fecha).toFormat('dd - MM - yyyy')
        }
    }
}
</script>